import {ValueObject} from '@s-ui/domain'

export class FilteredProvincesValueObject extends ValueObject {
  /**
   * @param {String} filteredProvinces
   */

  getFilteredProvinces() {
    return this._filteredProvinces
  }
}
